(function () {
  'use strict';

  var money = function (cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  };

  /* ---------- hero slideshow ---------- */
  function slideshow(root) {
    var slides = [].slice.call(root.querySelectorAll('.bsq-slide'));
    if (slides.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll('.bsq-hero__dot'));
    var speed = parseInt(root.dataset.speed, 10) || 5000;
    var i = 0, timer = null;

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d) {
        d.classList.remove('is-active');
        var bar = d.querySelector('span');
        bar.style.transition = 'none';
        bar.style.width = '0';
      });
      if (dots[i]) {
        var bar = dots[i].querySelector('span');
        void bar.offsetWidth;
        bar.style.transition = '';
        dots[i].classList.add('is-active');
      }
    }
    function play() { stop(); timer = setInterval(function () { go(i + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var prev = root.querySelector('.bsq-hero__arrow--prev');
    var next = root.querySelector('.bsq-hero__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { go(dx < 0 ? i + 1 : i - 1); play(); }
      x0 = null;
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    go(0);
    play();
  }

  /* ---------- accordions ---------- */
  function accordions(scope) {
    (scope || document).querySelectorAll('.bsq-acc__btn').forEach(function (b) {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var item = b.closest('.bsq-acc__item');
        var open = item.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- quantity ---------- */
  function quantity(scope) {
    (scope || document).querySelectorAll('.bsq-qty__box').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.dataset.dir === 'up' ? 1 : -1;
          input.value = Math.max(1, v);
        });
      });
    });
  }

  /* ---------- mobile nav ---------- */
  function mobileNav() {
    var btn = document.querySelector('.bsq-burger');
    var nav = document.querySelector('.bsq-nav');
    if (!btn || !nav || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- add to cart ---------- */
  function addToCart(id, qty, btn) {
    var label = btn ? btn.innerHTML : null;
    if (btn) btn.disabled = true;
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart.');
        window.location.href = window.routes.cart_url;
      })
      .catch(function (e) {
        alert(e.message);
        if (btn) { btn.disabled = false; if (label) btn.innerHTML = label; }
      });
  }

  function quickAdd() {
    if (document.body.dataset.bsqQuickAdd) return;
    document.body.dataset.bsqQuickAdd = '1';
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bsq-add]');
      if (!b) return;
      e.preventDefault();
      addToCart(b.dataset.bsqAdd, 1, b);
    });
  }

  /* ---------- PDP variant picker ---------- */
  function productForm(root) {
    var data = root.querySelector('[data-bsq-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var fmt = root.dataset.moneyFormat || '${{amount}}';
    var idInput = root.querySelector('[name="id"]');
    var atc = root.querySelector('.bsq-atc');
    var priceNow = root.querySelector('.bsq-price__now');
    var priceWas = root.querySelector('.bsq-price__was');
    var priceSave = root.querySelector('.bsq-price__save');
    var sku = root.querySelector('.bsq-pdp__sku');
    var first = true;

    function selected() {
      var opts = [];
      root.querySelectorAll('.bsq-opt').forEach(function (g) {
        var a = g.querySelector('.bsq-opt__pill.is-active');
        opts[parseInt(g.dataset.index, 10)] = a ? a.dataset.value : null;
      });
      return opts;
    }

    /*
     * syncMedia is false on first paint. Without that the initial render would
     * immediately overwrite the landing image Liquid chose, and the page would
     * open on a variant photo instead of the product's own first photo.
     */
    function showMedia(mediaId) {
      var hit = false;
      root.querySelectorAll('.bsq-gal__main img').forEach(function (m) {
        var on = String(m.dataset.media) === String(mediaId);
        m.classList.toggle('is-active', on);
        if (on) hit = true;
      });
      if (!hit) return;
      root.querySelectorAll('.bsq-gal__thumb').forEach(function (t) {
        t.classList.toggle('is-active', String(t.dataset.media) === String(mediaId));
      });
    }

    function render(syncMedia) {
      var opts = selected();
      var v = variants.find(function (x) {
        return x.options.every(function (o, k) { return opts[k] == null || o === opts[k]; });
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;

      if (priceNow) priceNow.textContent = money(v.price, fmt);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) {
        priceWas.textContent = onSale ? money(v.compare_at_price, fmt) : '';
        priceWas.style.display = onSale ? '' : 'none';
      }
      if (priceSave) {
        priceSave.textContent = onSale ? 'Save ' + money(v.compare_at_price - v.price, fmt) : '';
        priceSave.style.display = onSale ? '' : 'none';
      }
      if (sku && v.sku) sku.textContent = 'SKU: ' + v.sku;

      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? 'Add to cart' : 'Sold out';
      }

      /* No size gate here: chips live on the main stage precisely so this works. */
      if (syncMedia && v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);

      if (syncMedia && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.querySelectorAll('.bsq-opt__pill').forEach(function (p) {
      p.addEventListener('click', function () {
        p.parentNode.querySelectorAll('.bsq-opt__pill').forEach(function (o) { o.classList.remove('is-active'); });
        p.classList.add('is-active');
        render(true);
      });
    });

    var form = root.querySelector('form[data-bsq-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qty = form.querySelector('[name="quantity"]');
        addToCart(idInput.value, qty ? parseInt(qty.value, 10) : 1, atc);
      });
    }

    render(false);
    first = false;
  }

  /* ---------- PDP gallery ---------- */
  function gallery(root) {
    var thumbs = [].slice.call(root.querySelectorAll('.bsq-gal__thumb'));
    var mains = [].slice.call(root.querySelectorAll('.bsq-gal__main img'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        mains.forEach(function (m) {
          m.classList.toggle('is-active', String(m.dataset.media) === String(t.dataset.media));
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-bsq-slideshow]').forEach(slideshow);
    document.querySelectorAll('[data-bsq-product]').forEach(function (r) { productForm(r); gallery(r); });
    accordions();
    quantity();
    mobileNav();
    quickAdd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
